import PipelineStatusSelectorContainer from './containers/PipelineStatusSelectorContainer'

export default PipelineStatusSelectorContainer
